"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { Typography } from "@/shared/ui/atoms";
import { CustomButton } from "@/shared/ui/molecules";
import DemandSignalModal from "@/features/demand-signal/ui/DemandSignalModal";
import type { DemandSignalType } from "@/features/demand-signal/api";
import { pushDemandSignalEvent } from "@/features/demand-signal/lib/gtm";
type DemandSignalButtonsProps = {
  hospitalOriginId: number;
  /** bar = 모바일 하단 고정 바(가로 2분할), panel = 데스크톱 우측 패널(세로 스택) */
  variant?: "bar" | "panel";
  /**
   * 화면에 실제로 보이는지. 하단 바는 히어로를 지나야 올라오므로 마운트 시점에
   * 노출을 세면 전환율 분모가 부풀어 측정이 왜곡된다. 호출부가 알려 준다.
   */
  visible?: boolean;
  /** 바깥 여백은 호출부가 정한다 — 바와 패널의 여백 체계가 다르다. */
  className?: string;
};

/** 수요 조사 버튼(B2C-472). 파일럿 병원에서만 렌더된다 — 노출 판정은 호출부가 한다. */
const DemandSignalButtons = t0 => {
  const $ = _c(30);
  const {
    hospitalOriginId,
    variant: t1,
    visible: t2,
    className: t3
  } = t0;
  const variant = t1 === undefined ? "bar" : t1;
  const visible = t2 === undefined ? true : t2;
  const className = t3 === undefined ? "" : t3;
  const [openType, setOpenType] = useState(null);
  const viewedRef = useRef(false);
  let t4;
  let t5;
  if ($[0] !== hospitalOriginId || $[1] !== visible) {
    t4 = () => {
      if (!visible || viewedRef.current) {
        return;
      }
      viewedRef.current = true;
      pushDemandSignalEvent("demand_signal_view", hospitalOriginId);
    };
    t5 = [visible, hospitalOriginId];
    $[0] = hospitalOriginId;
    $[1] = visible;
    $[2] = t4;
    $[3] = t5;
  } else {
    t4 = $[2];
    t5 = $[3];
  }
  useEffect(t4, t5);
  let t6;
  if ($[4] !== hospitalOriginId) {
    t6 = signalType => {
      pushDemandSignalEvent("demand_signal_click", hospitalOriginId, signalType);
      setOpenType(signalType);
    };
    $[4] = hospitalOriginId;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const open = t6;
  const isPanel = variant === "panel";
  const t7 = `flex gap-2 ${isPanel ? "flex-col" : "items-center"} ${className}`;
  const t8 = `rounded-xl border border-gray-200 py-3 text-center ${isPanel ? "w-full" : "flex-1"}`;
  let t9;
  if ($[6] !== open) {
    t9 = () => open("REVIEW");
    $[6] = open;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const t10 = visible ? undefined : -1;
  let t11;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Typography as="span" size={15} lineHeight={20} className="font-semibold text-gray-800">리뷰 남기기</Typography>;
    $[8] = t11;
  } else {
    t11 = $[8];
  }
  let t12;
  if ($[9] !== t10 || $[10] !== t8 || $[11] !== t9) {
    t12 = <CustomButton className={t8} onClick={t9} tabIndex={t10}>{t11}</CustomButton>;
    $[9] = t10;
    $[10] = t8;
    $[11] = t9;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  const t13 = `rounded-xl bg-primary-600 py-3 text-center ${isPanel ? "w-full" : "flex-1"}`;
  let t14;
  if ($[13] !== open) {
    t14 = () => open("CONSULT_WAITLIST");
    $[13] = open;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  const t15 = visible ? undefined : -1;
  let t16;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Typography as="span" size={15} lineHeight={20} className="font-semibold text-white">상담 대기 신청</Typography>;
    $[15] = t16;
  } else {
    t16 = $[15];
  }
  let t17;
  if ($[16] !== t13 || $[17] !== t14 || $[18] !== t15) {
    t17 = <CustomButton className={t13} onClick={t14} tabIndex={t15}>{t16}</CustomButton>;
    $[16] = t13;
    $[17] = t14;
    $[18] = t15;
    $[19] = t17;
  } else {
    t17 = $[19];
  }
  let t18;
  if ($[20] !== t12 || $[21] !== t17 || $[22] !== t7) {
    t18 = <div className={t7}>{t12}{t17}</div>;
    $[20] = t12;
    $[21] = t17;
    $[22] = t7;
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  let t19;
  if ($[24] !== hospitalOriginId || $[25] !== openType) {
    t19 = openType && <DemandSignalModal open={true} hospitalOriginId={hospitalOriginId} signalType={openType} onClose={() => setOpenType(null)} />;
    $[24] = hospitalOriginId;
    $[25] = openType;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  let t20;
  if ($[27] !== t18 || $[28] !== t19) {
    t20 = <>{t18}{t19}</>;
    $[27] = t18;
    $[28] = t19;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  return t20;
};
export default DemandSignalButtons;